<app-header></app-header>
<div class="body-container clearfix">
    <div *ngIf="!errorGettingOffers">
        <div class="row">
            <div class="col-12 box">
                <div class="col-12 box-title">
                    Select your payment options below
                </div>
            </div>
        </div>
        <div class="row table-container">
            <div class="col-12">
                <div class="box-child clearfix">
                    <form (ngSubmit)="selectoffer()" [formGroup]="selectedOfferGroup">
                        <table class="table table-striped table-hover" aria-describedby="offers table">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">Term</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Payment</th>
                                    <th scope="col">Selected</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let offer of offers.offerList">
                                    <th scope="row"> {{offer.term}} </th>
                                    <td> {{ (offer.useMaxApprovedAmount ? offers.maxApproved : offers.requestAmount) |
                                        currency:'$ ':'code':'.0-0'}}
                                    </td>
                                    <td> {{ offer.payment | currency:'$ ':'code':'.2-2' }} </td>
                                    <td>
                                        <input type="radio" id="offer{{offer.offerId}}" [value]="offer.offerId"
                                            formControlName="selectedOfferControl" name="selectedOfferControl">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 class="font-mont-semi-bold">ACH Payments are required for all transactions</h4>
                        <div class="row">
                            <div class="col-12">
                                <button type="submit"
                                    class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular">
                                    CONTINUE
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="errorGettingOffers">
        <div class="row">
            <div class="col-12 box">
                <div class="col-12 box-title">
                    Unfortunately, we are unable to approve your request at this time.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 box">
                <div class="col-12 box-error-message">
                    Unfortunately, we are unable to approve your request at this time. We hope to have another
                    opportunity to support your financing needs.
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>